const run_mode = process.env.VUE_APP_API_ENV;

// let apiUrl = 'https://dev-v1.api.carbonwize.io/api/v1'
let apiUrlConfig = null;

switch(run_mode) {
    case 'uat': apiUrlConfig = 'https://uat.api.carbonwize.io/api/v1'
        break;
    case 'develop': apiUrlConfig = 'https://dev.api.carbonwize.io/api/v1'
        break;
    case 'prod': apiUrlConfig = 'https://api.carbonwize.io/api/v1'
        break;
    default: apiUrlConfig = 'https://dev.api.carbonwize.io/api/v1'
    // case 'uat' : apiUrlConfig = 'https://uat-v1.api.carbonwize.io/api/v1'
    // break;
    // case 'develop' : apiUrlConfig = 'https://dev-v1.api.carbonwize.io/api/v1'
    // break;
    // case 'prod' : apiUrlConfig = 'https://api-v1.carbonwize.io/api/v1'
    // break;
    // default: apiUrlConfig = 'https://uat-v1.api.carbonwize.io/api/v1'
}


export const apiURL = apiUrlConfig
